export default __webpack_public_path__ + "bcd02d2.png";